import React from "react";
import { PASSWORD_RULES } from "lib/passwordPolicy";

export default function PasswordFields({ password, confirmation, onPassword, onConfirmation, disabled = false }) {
  const cls = "w-full px-4 py-2 rounded-md border border-app input-app focus:outline-none focus-visible:ring-app";
  return (
    <>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label className="block mb-1 font-medium">Set Password</label>
          <input type="password" autoComplete="new-password" value={password} onChange={(e) => onPassword(e.target.value)} className={cls} disabled={disabled} required />
        </div>
        <div>
          <label className="block mb-1 font-medium">Confirm Password</label>
          <input type="password" autoComplete="new-password" value={confirmation} onChange={(e) => onConfirmation(e.target.value)} className={cls} disabled={disabled} required />
        </div>
      </div>
      <div className="text-sm text-muted">
        <p className="mb-1 font-medium">Valid password rules:</p>
        <ul className="list-inside list-disc text-xs">{PASSWORD_RULES.map((rule) => <li key={rule}>{rule}</li>)}</ul>
      </div>
    </>
  );
}
